import { getDesktopApi } from '@renderer/lib/desktop-api';

export async function getDashboardOverview() {
  return getDesktopApi().dashboard.getOverview();
}
